import { connect } from 'react-redux';

import {
  selectNavigatedFromOrToPageOne,
  selectRedirectedFromSearch,
} from 'src/components/organisms/ProductPage/modules/selectors';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { HeaderCopyBlock } from '../components/HeaderCopyBlock';

const mapStateToProps = (state: ReduxApplicationState) => ({
  categoryDescription: state.products.category.description,
  navigation: state.products.navigation,
  categoryHeading: state.products.category.heading,
  navigatedFromOrToPageOne: selectNavigatedFromOrToPageOne(state),
  redirectedFromSearch: selectRedirectedFromSearch(state),
});

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
